import { Component, Input, OnInit } from "@angular/core";
import { LinkTarget } from "src/app/types/link";

interface ParticipatingStoresItem {
  name: string;
  value: string;
}

interface ParticipatingStoresInterface {
  title: string;
  items: ParticipatingStoresItem[] | string;
  template: string;
}

@Component({
  selector: "app-participating-stores",
  templateUrl: "./participating-stores.component.html",
  styleUrls: ["./participating-stores.component.scss"],
})
export class ParticipatingStoresComponent implements OnInit {
  columnCount: number;

  @Input() node: ParticipatingStoresInterface;

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = parseInt(this.node.template.replace("grid-", ""));
  }
}
